// extracted by mini-css-extract-plugin
export default {"walletAltIcon":"CustomButton_walletAltIcon__jjwxE","actionButton":"CustomButton_actionButton__Wg8HM","connectwalletbuttom":"CustomButton_connectwalletbuttom__q4ZKK"};